import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCard } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

import { CheckoutPaymentTypeAdapter } from '@spartacus/checkout/b2b/core';
import { CartNotEmptyGuard, CheckoutAuthGuard } from '@spartacus/checkout/base/components';
import { I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { FormErrorsModule, SpinnerModule } from '@spartacus/storefront';

import { DpOccCheckoutPaymentTypeAdapter } from '../../adapters';
import { DpPurchaseOrderNumberComponent } from './../purchase-order-number/purchase-order-number.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    FormErrorsModule,
    SpinnerModule,
    MatCard,
    MatIcon,
    UrlModule,
    RouterLink
  ],
  providers: [
    {
      provide: CheckoutPaymentTypeAdapter,
      useClass: DpOccCheckoutPaymentTypeAdapter
    },
    provideConfig({
      cmsComponents: {
        CheckoutPurchaseOrderNumber: {
          component: DpPurchaseOrderNumberComponent,
          guards: [CheckoutAuthGuard, CartNotEmptyGuard]
        }
      }
    })
  ],
  declarations: [DpPurchaseOrderNumberComponent],
  exports: [DpPurchaseOrderNumberComponent]
})
export class DpPurchaseOrderNumberModule {}
